/**
 * TanStack Query hooks for `regional-dns`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	regionalDnsQueryKeys,
	type CreateRegionalDnsBody,
	type ListRegionalDnsResponse,
	type RegionalDnsRow,
} from "./api";

export function useRegionalDnsList(): UseQueryResult<ListRegionalDnsResponse, Error> {
	return useQuery({
		queryKey: regionalDnsQueryKeys.list(),
		queryFn: list,
	});
}

export function useRegionalDnsCreate(): UseMutationResult<RegionalDnsRow, Error, CreateRegionalDnsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: regionalDnsQueryKeys.all });
		},
	});
}

export function useRegionalDnsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: regionalDnsQueryKeys.all });
		},
	});
}
